import { useState } from 'react'
import { Atom } from 'klyva/dist/types'
import { atom } from 'klyva'

const useNewKlyvaAtom = <T>(makeInitValue: () => T) => {
  const [createdAtom] = useState<Atom<T>>(() => atom(makeInitValue()))
  return createdAtom
}

export default useNewKlyvaAtom
